<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
    <circle id="list" cx="6" cy="6" r="6" fill="#4c6c8c"/>
  </svg>
  